export const KeyMomentCategory = {
  GOAL: 'goal',
  CARD: 'card',
  SUBSTITUTION: 'substitution',
  MATCH_STATUS: 'match_status',
};

export const CardColor = {
  YELLOW: 'yellow',
  RED: 'red',
};

export const DEFAULT_VISIBLE_CATEGORIES = [
  KeyMomentCategory.GOAL,
  KeyMomentCategory.CARD,
  KeyMomentCategory.SUBSTITUTION,
  KeyMomentCategory.MATCH_STATUS,
];

export const DEFAULT_MARKER_CATEGORIES = [
  KeyMomentCategory.GOAL,
  KeyMomentCategory.CARD,
  KeyMomentCategory.SUBSTITUTION,
  KeyMomentCategory.MATCH_STATUS,
];

export const DEFAULT_KEY_MOMENT_LABELS = {
  goal: 'Goal',
  yellowCard: 'Yellow Card',
  redCard: 'Red Card',
  substitution: 'Substitution',
  matchStatus: 'Status',
  unavailable: 'Unavailable',
};

export const DEFAULT_POLLING_INTERVAL = 20_000;
